import Input from "../../components/ui/Input";
import Button from "../../components/ui/Button";
import { ReactComponent as Close } from "../../components/ui/styles/Icon_Close.svg";
import { ReactComponent as Plus } from "../../components/ui/styles/plus_icon.svg";
import Modal from "../../components/ui/Modal";
import styled from "styled-components";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { addDomain } from "../../redux/features/PlatformSettingSlice";

export const ModalCard = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 12%);
  // overflow: hidden;
  width: 750px;
`;

export const ModalCardBody = styled.div`
  padding: 22px;
  margin: 0;
  list-style-type: none;
  background: #fff;
  ul {
    padding: 0;
    list-style-type: none;
    text-align: left;
    margin: 10px 0;
    li {
      font-size: 14px;
      font-weight: 400;
      color: #999;
      line-height: 20px;
      span {
        font-weight: 700;
      }
    }
  }
`;

export const ModalCardHead = styled.div`
  border-bottom: 1px solid #ed8154;
  background: #ed8154;
  padding: 8px 22px;
  padding-right: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;

  h6 {
    font-size: 16px !important;
    color: #fff !important;
    margin: 0;
    font-weight: 600;
  }
  button {
    padding: 0;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ModalCardForm = styled.div`
  width: 100%;
  input {
    width: 100%;
    border: 1px solid #ddd;
    min-height: 40px;
    box-sizing: border-box;
    padding: 8px 12px;
    border-radius: 8px;
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
  label {
    font-size: 14px !important;
    color: #666 !important;
    margin: 0;
    width: 100%;
    text-align: left;
    display: block;
    margin-bottom: 6px;
    font-weight: 700;
  }
`;

export const InputBox = styled.div`
  margin-bottom: 20px;
  & > div > div {
    border-color: #ddd;
  }
`;

export const ModalCardButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 22px;

  button {
    font-size: 14px;
    color: #fff;
    background: #ed8154;
    border: 1px solid #ed8154;
    border-radius: 8px;
    overflow: hidden;
    padding: 8px 20px;
    min-width: 95px;
    margin-left: 12px;
    font-weight: 600;
    &:first-of-type {
      margin-left: 0;
      background: #fff;
      color: #ed8154;
    }
  }
`;

const domainReg = /^(?=.{1,253}$)(?!\-)(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

const AddDomainModal = () => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [domain, setDomain] = useState('');

    const domainNameError = domain && !domainReg.test(domain.trim());

    const close = () => setOpen(false);
    const add = () => {
        dispatch(addDomain({ domain }));
        close();
    };

    return (
        <>
            <Button
                className="iconButton"
                onClick={() => setOpen(true)}
            >
                <Plus />
            </Button>
            <Modal show={open} >
                <ModalCard>
                    <ModalCardHead>
                        <h6>Add domain</h6>
                        <div style={{ cursor: 'pointer', padding: 10 }} onClick={close}>

                            <Close />
                        </div>
                    </ModalCardHead>
                    <ModalCardBody>
                        <ModalCardForm>
                            <InputBox>
                                <label>Domain</label>
                                <Input
                                    value={domain}
                                    onChange={(e) => setDomain(e.target.value)}
                                    style={domainNameError ? {
                                        border: '1px solid #C93E3E'
                                    } : {}}
                                    placeholder="Enter domain (e.g. qone-tech.com)"
                                />
                            </InputBox>

                        </ModalCardForm>
                        <ModalCardButtons>
                            <Button onClick={close}>
                                Close
                            </Button>
                            <Button
                                disabled={domainNameError}
                                id="b-login"
                                onClick={add}
                            >
                                Save
                            </Button>
                        </ModalCardButtons>
                    </ModalCardBody>
                </ModalCard>
            </Modal>


        </>

    )
}

export default AddDomainModal;